import { ChatBase } from "@Base/Engagement/Chat/ChatBase";
import { IQuiqOptions } from "@Base/Engagement/Chat/IQuiqOptions";
import { TextResource } from "@Utilities/TextResource";

export class Chat extends ChatBase
{
	constructor()
	{
		super();
	}

	public override GetSiteOptions(): IQuiqOptions
	{
		const primary = "#683895";
		const primaryBorder = `1px solid ${primary}`;
		const secondary = "#e6e6e6";
		const bodyColor = "#3b3b3b";
		/*
		* These options are provided to the Quiq chat object on initialization.
		* NOTE: Chat options can be overridden at the site level for various look-and-feel details.
		*
		* See the full list of available options that can be configured for Quiq chat:
		* https://developers.goquiq.com/docs/webchat/#/reference/types
		*/
		const siteOptions: IQuiqOptions = {
			contactPoint: "fancydresscom",
			colors: {
				primary: primary,
				agentMessageDropdownButtonBackground: primary,
				agentMessageLinkText: primary,
				agentMessageText: bodyColor,
				customerMessageBackground: secondary,
				customerMessageText: bodyColor
			},
			styles: {
				HeaderMenu: {
					backgroundColor: primary,
					color: "white",
					fontWeight: "600"
				},
				HeaderMenuIcons:
				{
					color: "#fff"
				},
				HeaderBanner: {
					backgroundColor: primary,
					color: "#fff",
					fontWeight: "600"
				},
				WelcomeFormBanner:
				{
					backgroundColor: primary
				},
				WelcomeFormSubmitButton: {
					borderColor: primary,
					backgroundColor: primary
				},
				AgentRichMessage: {
					button: {
						borderColor: secondary,
						color: bodyColor,
						fontWeight: "600",
						borderRadius: "50rem"
					}
				},
				InlineActionButton: {
					border: primaryBorder,
					color: primary
				},
				MessageFormInput: {
					color: bodyColor
				},
				MessageFormSend: {
					backgroundColor: primary,
					color: "#fff",
					fontWeight: "600",
					borderRadius: "50rem"
				},
				OptionsMenuLineItem: {
					color: primary
				},
				OptionsMenuLineItemIcon: {
					color: primary
				}
			},
			messages: {
				headerText: TextResource.GetTextByCulture("Feature_Chat_AskAnythingFancy")
			}
		};

		if (TextResource.GetLanguage() === "es")
		{
			siteOptions.language = "es";
		}

		return siteOptions;
	};
}